<template>
    <v-container>
        <!--v-layout align-center justify-center-->
        <v-layout align-center justify-center>
            <v-loading class="loading" v-model="loading" v-if="loading">
    
                <v-progress-circular persistent
                :size="70"
                :width="7"
                color="primary"
                indeterminate
                ></v-progress-circular>
        
            </v-loading>
            <v-flex xs12 sm8 md4>
                <!--v-card class="elevation-12"-->
                <v-card>
                    <v-toolbar dark color="primary">
                        <v-toolbar-title><a href="javascript:history.back()" class="voltar"><img class="imgVoltar" :src="imgVoltar"></a>Criar Enquete</v-toolbar-title>
                    </v-toolbar>
                    <v-card-text>
                        <!--v-form ref="form" v-model="valid" lazy-validation-->
                        <v-form ref="form" v-model="valid" lazy-validation>
           
                            <v-text-field name="pergunta" label="Pergunta" type="text"
                                          v-model="pergunta" required>
                            </v-text-field>


                            <v-layout row wrap>
                                <v-flex xs10 sm10 md10>
                                    <v-card-text style="padding:0 0 0 0; width:100%"> 
                                        <v-text-field name="resposta" label="Resposta" type="text"
                                            v-model="resposta" required>
                                        </v-text-field>
                                    </v-card-text>
                                </v-flex>
                                <v-flex xs2 sm2 md2>
                                    <v-btn fab dark color="green" text-xs-right @click="adicionarPerguntasArray" class="adicionarItem btCirculo">
                                        <a>+</a>
                                    </v-btn>
                                    
                                </v-flex>
                                <div class="box-items-selecionados">
                                    <v-layout row wrap v-for="itemsRespostaAdicionada in itemsRespostasAdicionadas">
                                        <v-flex xs10 sm10 md10>{{ itemsRespostaAdicionada }}</v-flex>
                                        <v-flex xs2 sm2 md2><v-btn fab dark color="red" class="excluirItem btCirculo" text-xs-right @click="removerPerguntaArray(itemsRespostaAdicionada)">-</v-btn></v-flex>
                                    </v-layout>
                                    
                                </div>
                            </v-layout>


                            <br />
                            <!-- inicio - plugin compressor de imagem -->
                            <!-- <label class="v-label theme--light">Imagem:</label>
                            <image-compressor class="compressor" :done="getFiles" :scale="scale" :quality="quality" ref="compressor"></image-compressor>

                            <div style="display:none" class="checkbox">
                            <input type="checkbox" v-model="originalSize">
                            <span>Responsive Image?</span>
                            </div>

                            <div style="display:none" class="input-group">
                            <label>Image Scale</label>
                            <input type="number" v-model="scale">
                            </div>

                            <div style="display:none" class="input-group">
                            <label>Image Quality</label>
                            <input type="number" v-model="quality">
                            </div>

                            <div class="image-info" v-if="img">
                                <b>Before: </b>
                                <span>{{ original.size }}</span>
                                <span class="separator"> | </span>
                                <b>After: </b>
                                <span>{{ compressed.size }}</span>
                            </div>

                            <div style="display: none" class="text-center" v-if="img">
                            <img v-if="img" src="" alt="" :style="{ maxWidth: originalSize ? '100%' : null }" :src="img">
                            <a :href="img" class="button" target="_blank">Download</a>
                            </div>
                            <b v-if="img">Preview da imagem: </b>
                            <div class="text-center imagem" v-if="img">
                                <img v-if="img" src="" alt="" :src="img">
                            </div> -->
                            <!-- Fim - plugin compressor de imagem -->
                            <!-- <br /><br /> -->
                            
                            <v-layout row wrap>
                                <v-flex xs11 sm5>
                                    <v-menu
                                    lazy
                                    :close-on-content-click="false"
                                    v-model="menu"
                                    transition="scale-transition"
                                    offset-y
                                    full-width
                                    :nudge-right="40"
                                    max-width="290px"
                                    min-width="290px"
                                    >
                                    <v-text-field
                                        slot="activator"
                                        label="Data Inicio"
                                        v-model="dateStart"
                                        prepend-icon="event"
                                        readonly
                                    ></v-text-field>
                                    <v-date-picker v-model="dateStart" no-title scrollable actions>
                                        <!-- <template scope="{ save, cancel }"> -->
                                        <v-card-actions>
                                            <v-spacer></v-spacer>
                                            <!-- <v-btn flat color="primary" @click="cancel">Cancel</v-btn> -->
                                            <v-btn class="buttonOk" flat color="primary" @click="save">OK</v-btn>
                                        </v-card-actions>
                                        <!-- </template> -->
                                    </v-date-picker>
                                    </v-menu>
                                </v-flex>
                            </v-layout>

                            <v-layout row wrap>
                                <v-flex xs11 sm5>
                                    <v-menu
                                    lazy
                                    :close-on-content-click="false"
                                    v-model="menu2"
                                    transition="scale-transition"
                                    offset-y
                                    full-width
                                    :nudge-right="40"
                                    max-width="290px"
                                    min-width="290px"
                                    >
                                    <v-text-field
                                        slot="activator"
                                        label="Data Final"
                                        v-model="dateEnd"
                                        prepend-icon="event"
                                        readonly
                                    ></v-text-field>
                                    <v-date-picker v-model="dateEnd" no-title scrollable actions>
                                        <!-- <template scope="{ save, cancel }"> -->
                                        <v-card-actions>
                                            <v-spacer></v-spacer>
                                            <!-- <v-btn flat color="primary" @click="cancel">Cancel</v-btn> -->
                                            <v-btn class="buttonOk" flat color="primary" @click="save">OK</v-btn>
                                        </v-card-actions>
                                        <!-- </template> -->
                                    </v-date-picker>
                                    </v-menu>
                                </v-flex>
                            </v-layout>

                            <!-- <v-layout row wrap>
                                <v-flex xs11 sm5>
                                    <v-switch
                                        v-model="preview"
                                        :label="`Preview: ${preview.toString()}`"
                                    ></v-switch>
                                    <label>Se o preview estiver habilitado, somente você verá o evento.</label>
                                </v-flex>
                            </v-layout> -->

                            <v-layout row wrap>
                                <v-flex xs11 sm5>
                                    <v-switch
                                        v-model="push"
                                        :label="`Push: ${push.toString()}`"
                                    ></v-switch>
                                    <label>Se o push estiver habilitado será enviado uma notificação para todos usuários da escola.</label>
                                </v-flex>
                            </v-layout>

                            <v-text-field v-if="push == true" browser-autocomplete="new-texto-push" name="textoPush" label="Digite o texto do push" type="text"
                                          v-model="textoPush">
                            </v-text-field>

                            
                            
                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <!--v-btn color="primary" :disabled="!valid" @click="submit" data-cy="joinSubmitBtn">Cadastrar</v-btn-->
                        <v-btn color="primary" :disabled="!valid || !statusUpload" @click="criarEnquete" data-cy="joinSubmitBtn">Criar</v-btn>
                    </v-card-actions>
                </v-card>
            </v-flex>
        </v-layout>
        <v-dialog v-model="dialog" persistent max-width="290">
            <v-card>
                <v-card-title class="headline">{{tituloModal}}</v-card-title>
                <!--v-card-text>Let Google help apps determine location. This means sending anonymous location data to Google, even when no apps are running.</v-card-text-->
                <v-card-actions>
                <v-spacer></v-spacer>
                <!--v-btn color="green darken-1" flat @click="dialog = false">Disagree</v-btn-->
                <v-btn color="green darken-1" flat @click="closeModal">OK</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialogUpload" max-width="290">
            <v-card>
                <v-card-title class="headline">{{tituloModal}}</v-card-title>
                <!--v-card-text>Let Google help apps determine location. This means sending anonymous location data to Google, even when no apps are running.</v-card-text-->
                <v-card-actions>
                <v-spacer></v-spacer>
                <!--v-btn color="green darken-1" flat @click="dialog = false">Disagree</v-btn-->
                <v-btn color="green darken-1" flat @click="dialogUpload = false">OK</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import db from './firebaseInit';
import firebase,{ storage } from 'firebase';

import {mask} from 'vue-the-mask'

import { userProperties } from '@/global.js'
import { userInfo } from 'os';

import axios from 'axios'
import VueAxios from 'vue-axios'

import imgVoltar from '../assets/ic-voltar.png';

//Vue.use(VueAxios, axios)

import imageCompressor from 'vue-image-compressor' // https://vuejsfeed.com/blog/compress-image-files-with-vue-2-image-compressor

export default {
    name: 'Criar-Enquete',
    directives: {mask},
    
    data: vm => ({
        imgVoltar: imgVoltar,
        // Dados do compressor de imagens - Inicio 
        dialogUpload: false,
        img: "",
        scale: 100,
        quality: 50,
        originalSize: true,
        original: {},
        compressed: {},
        tresVezes: 0,
        // Dados do compressor de imagens - Fim 
        valid: false,
        timestamp: null,
        dialog: false,
        loading: false,
        slug: null,
        extensao : null,
        statusUpload: true,
        tituloModal: "Enquete criada com sucesso!",
        dateStart: new Date().toISOString().substr(0, 10),
        dateEnd: new Date().toISOString().substr(0, 10),
        dateFormatted: vm.formatDate(new Date().toISOString().substr(0, 10)),
        //preview: false,
        menu: false,
        menu2: false,
        pushIDs: null,
        push: false,
        textoPush: null,
        pergunta: '',
        resposta: '',
        itemsRespostasAdicionadas: []
    }),
    // computed: {
    //     computedDateFormatted () {
    //         return this.formatDate(this.dateStart)
    //     }
    // },
    // watch: {
    //     date (val) {
    //         this.dateFormatted = this.formatDate(this.dateStart)
    //     }
    // },
    components: { imageCompressor },
    methods: { // ####################### Criar parte que criar documentos collections de cada escola ao realizar primeiro login do usuario Escola
        formatDate (dateStart) {
            if (!dateStart) return null

            const [year, month, day] = dateStart.split('-')
            return `${month}/${day}/${year}`
        },
        parseDate (dateStart) {
            if (!dateStart) return null

            const [month, day, year] = dateStart.split('/')
            return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
        },
        criarEnquete(){
            this.tituloModal = "Enquete criada com sucesso!";

            var that = this;
            if(userProperties.escolaID != null){
                this.loading = true
                // timestamp
                var now = new Date();
                var year = "" + now.getFullYear();
                var month = "" + (now.getMonth() + 1); if (month.length == 1) { month = "0" + month; }
                var day = "" + now.getDate(); if (day.length == 1) { day = "0" + day; }
                var hour = "" + now.getHours(); if (hour.length == 1) { hour = "0" + hour; }
                var minute = "" + now.getMinutes(); if (minute.length == 1) { minute = "0" + minute; }
                var second = "" + now.getSeconds(); if (second.length == 1) { second = "0" + second; }
                //return year + "-" + month + "-" + day + " " + hour + ":" + minute + ":" + second;
                var customtimestamp = year + month + day + hour + minute + second

                db.collection('enquete').add({
                        escolaID: userProperties.escolaID,
                        slugAutor: userProperties.slug,
                        
                        slug: this.slug,
                        customtimestamp: customtimestamp,
                        extensao: this.extensao,
                        dateStart: this.dateStart,
                        dateEnd: this.dateEnd,
                        //preview: this.preview,
                        push: this.push,
                        textoPush: this.textoPush,

                        pergunta: this.pergunta,
                        respostas: this.itemsRespostasAdicionadas,
                        
                    })
                    .then(docRef => {

                        if(this.push == true){

                            function loop(item, index) {
                                    var postData = {
                                    "notification": {        
                                        "title": "Nova Enquete!",
                                        "body": that.textoPush,
                                        "click_action": "https://inclass.app",
                                        "icon": "https://firebasestorage.googleapis.com/v0/b/projetox-688ca.appspot.com/o/sistema%2Ficone-push%2Ficon-192x192-push.png?alt=media",
                                        "badge": "https://firebasestorage.googleapis.com/v0/b/projetox-688ca.appspot.com/o/sistema%2Ficone-push%2Ficon-192x192-push.png?alt=media",
                                        //"image": "https://firebasestorage.googleapis.com/v0/b/projetox-688ca.appspot.com/o/sistema%2Ficone-push%2Ficon-192x192-push.png?alt=media",
                                        "sound": "default"
                                    },    
                                    //"to": "egWUxBfoF_M:APA91bFI3XEPVD6dFP9W2_G__J9DzbTb9qpmFBW0NGRhcBTVxdNM_j_VOKo5V79Ro1-jmZLXYv6Wzq39ELzMUW-TTHAS7Nb6FSt762n_8E7SCwtHfFwn-QRClj3SD5mH2iO5sijMHY0a"
                                    "to": item
                                }

                                let axiosConfig = {
                                    headers: {
                                        'Content-Type': 'application/json',
                                        "Authorization": "key=AAAAiOjxl8Q:APA91bHly_RtJvUwP5kzHiHbulyRMI7oChExHjzyf1MFimlObjrX_-kRxCMWW77a2hBBxU7Oz-BhnFBANbCBHMObkiKAMHZSgxfw47LKjwGTRs6DCjtDkvvyRLiJcCMBHHh4uS93E0ha",
                                    }
                                };

                                axios.post('https://fcm.googleapis.com/fcm/send', postData, axiosConfig)
                                .then((res) => {
                                    console.log("PUSH ENVIADO. RESPONSE RECEIVED: ", res);
                                })
                                .catch((err) => {
                                    console.log("ERRO AO ENVIAR PUSH. AXIOS ERROR: ", err);
                                    alert("Erro no envio de push.")
                                })
                            }

                            this.pushIDs.forEach(loop);
                        }

                        

                        console.log('Document written with ID: ', docRef.id);
                        //this.$router.push(`/${slug}/success`)
                        this.loading = false
                        this.dialog = true
                        
                    })
                    .catch(function (error) {
                        that.loading = false
                        console.log('Error adding document: ', error);
                        console.log("Erro no envio dos dados. Tente novamente mais tarde!")
                    })
            }
            else{
                alert("Sua sessão expirou, você será redirecionado para reautenticar!");
                this.$router.push(`/`);
            }
            
        },
        closeModal(){
            this.$router.push(`/Enquete-Listagem`);
        },        
        submit() {
            if (this.$refs.form.validate() && this.statusUpload == true) {
            }
            if (this.$refs.form.validate() && this.statusUpload == false) {
                alert("Por favor, faça o upload da foto do perfil do usuário")
            } 
        },
        generateUUID () {
          let d = new Date().getTime()
          let uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            let r = (d + Math.random() * 16) % 16 | 0
            d = Math.floor(d / 16)
            return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16)
          })
          return uuid
        },
        // onFileSelected(event){
        //     this.loading = true;
        //     console.log(event);
        //     var file = event.target.files[0]
        //     var filename = event.target.files[0].name
            
        //     // Recupera imagem do storage
        //     var storageRef = firebase.storage().ref('eventos/'+this.slug+"."+filename.toString().split(".")[1])
        //     this.extensao = filename.toString().split(".")[1];
        //     var task = storageRef.put(file)
        //     var that = this;
        //     task.on('state_changed',
        //         function progress(snapshot){
        //             var percentage = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        //             uploader.value = percentage;
        //             that.loading = false;
        //         },
        //         function error(err){
        //             alert("Error on upload. Check if image size is less than 900KB");
        //             that.statusUpload = false;
        //             that.loading = false;
        //         },
        //         function complete(){
        //             that.extensao = filename.toString().split(".")[1];
        //             that.statusUpload = true;
        //             alert("Upload successful!");
        //             that.loading = false;
        //         }
        //     )
        // }
        upload () {
            let compressor = this.$refs.compressor.$el
            compressor.click()
        },
        save() {
            this.menu = false;
            this.menu2 = false;
        },
        getFiles(obj){
            this.tresVezes = this.tresVezes + 1; // gambiarra do bug de executar 3 vezes
            

            this.img = obj.compressed.blob
            this.original = obj.original
            this.compressed = obj.compressed
            var escala = 0;
            var qualidade = 0;

            if(Number(obj.original.size.split(" ")[0]) > 4000){
                escala = 40;
                qualidade = 60;
            }
            else if(Number(obj.original.size.split(" ")[0]) > 3000 && Number(obj.original.size.split(" ")[0]) <= 4000){
                escala = 55;
                qualidade = 60;
            }
            else if(Number(obj.original.size.split(" ")[0]) > 2000 && Number(obj.original.size.split(" ")[0]) <= 3000){
                escala = 70;
                qualidade = 70;
            }
            else if(Number(obj.original.size.split(" ")[0]) > 1000 && Number(obj.original.size.split(" ")[0]) <= 2000){
                escala = 80;
                qualidade = 70;
            }
            else if(Number(obj.original.size.split(" ")[0]) > 500 && Number(obj.original.size.split(" ")[0]) <= 1000){
                escala = 90;
                qualidade = 80;
            }
            else{
                escala = 100;
                qualidade = 90;
            }

            this.scale = escala;
            this.quality = qualidade;
            //console.log(obj);
            this.loading = true;
            //console.log(event);
            if(this.tresVezes >= 2){
                this.tresVezes = 0;
                
                
                var file = obj.compressed.file

                var imageURL = obj.compressed.blob;
                
                var metadata = { contentType: 'image/jpeg'};
                //var metadata = { contentType: obj.original.type};
                var getFileBlob = function (url, cb) {
                    var xhr = new XMLHttpRequest();
                    xhr.open("GET", url);
                    xhr.responseType = "blob";
                    xhr.addEventListener('load', function() {
                        cb(xhr.response);
                    });
                    xhr.send();
                };
                //var uploadToStorage = (imageURL) => {

                    getFileBlob(imageURL, blob =>{
                        var filename = obj.compressed.file.name;
                        this.extensao = filename.toString().split(".")[1];
                        //this.scale = 40
                        
                        firebase.storage().ref().child('enquete/'+this.slug+"."+filename.toString().split(".")[1]).put(blob, metadata)
                            .then(snapshot => {
                                this.loading = false
                                this.dialogUpload = true
                                this.tituloModal = "Upload da imagem realizado com sucesso!"
                                this.statusUpload = true;
                            })
                            .catch( (error) => {
                                this.loading = false
                                this.dialogUpload = true
                                this.tituloModal = "Erro ao realizar upload da imagem. Tente novamente!"
                            })
                    })
                //}
                
            }
            
            
      },
      adicionarPerguntasArray(){
          alert(this.resposta)
            if(this.resposta != ""){
                this.itemsRespostasAdicionadas.push(this.resposta);
        
                // Remove itens repetidos do array
                var groupsOfResult = [];

                groupsOfResult = this.itemsRespostasAdicionadas.filter(function (a) {
                    return !this[JSON.stringify(a)] && (this[JSON.stringify(a)] = true);
                }, Object.create(null))

                this.itemsRespostasAdicionadas = groupsOfResult;
            }

            this.reinderizar = true;
            //console.log(this.turmas);
            console.log(this.itemsRespostasAdicionadas);
        }
        
    },
    removerPerguntaArray(value) {
        
    },
    mounted() {
        const slug = this.generateUUID()
        this.slug = slug;

        // se perfil não for escola ou administrador
        if(userProperties.perfil == 1 || userProperties.perfil == 5 || userProperties.perfil == 6 || userProperties.perfil == 7){
            alert("Acesso negado!");
            this.$router.push(`/?redirect=`+window.location.pathname)
        }

        // Pega todos os token FCM da escola para enviar o push
        var tokensFMC = [];
        db.collection('usuarios').where("escolaID", "==", userProperties.escolaID)
        .get()
        .then((querySnapshot) => {
            querySnapshot.forEach(doc => {
                // doc.data() is never undefined for query doc snapshots
                console.log(doc.id, " => ", doc.data());               
                let customObj = doc.data()
                if(customObj.tokenFMC != undefined && customObj.tokenFMC != "")
                    tokensFMC.push(customObj.tokenFMC)
            });

            //tokensFMC = tokensFMC.substring(0, tokensFMC.length -1);
            this.pushIDs = tokensFMC;

            this.loading = false;

        });
    }
};
</script>

<style scoped>
    .loading{
        position: absolute;
        top:20%;
        left:48%;
        z-index: 2;
    }

    .btCirculo{
        height: 30px;
        width: 30px;
    }

    .btCirculo a{
        color:#fff;
    }

    progress{
        width:100%;
        margin-top: 6px;
    }

    label.v-label.theme--light{
        margin-bottom: 6px;
        display: block
    }

    .adicionarItem.btCirculo{
        position: relative;
        top: 12px;
        left: 5px;
    }

    .excluirItem.btCirculo{
        position: relative;
        left: 5px;
        top:-10px;
    }

    .box-items-selecionados{
        background: silver;
        width: 100%;
        padding: 20px 5px 5px 10px;
    }

    .container{
        padding: 0 0 !important;
    }

    .imagem img{
        width: 100%;
        margin-top: 8px;
    }

    .buttonOk{
        position: absolute;
        right: 2px;
        bottom: 5px;
    }

    .box-items-selecionados{
        background: silver;
        width: 100%;
        padding: 20px 5px 5px 10px;
    }
</style>
